<div *ngIf="block && block.data.value" class="pl-inner-html" [innerHTML]="block.data.value | safeHtml"></div>
